import { Component, h } from 'preact';
import { PaxAmount, PaxAmountKey, PaxSelectionOption, TravelClass } from '../../../../common';
import { Column } from '../../../../common/Layout/Layout';
import { ModalProps } from '../../../../modal';
import { Actions, actions, connectStore } from '../../../../store';
import { WithStyles, withStyles } from '../../../../style';
import { getPaxSelectionOptions } from '../../paxAmountUtils';
import { PaxAmountModalBase } from '../PaxAmountModalBase';
import PaxSelection from '../PaxSelection/PaxSelection';
import TravelClassRadio from '../../../TravelClassSelector/TravelClassRadio/TravelClassRadio';

export interface PaxAmountModalProps extends ModalProps {}

interface StoreProps {
  paxAmount: PaxAmount;
  travelClass: TravelClass;
  travelClasses: TravelClass[];
  enableCompactWidget: boolean;
}

type EffectiveProps = PaxAmountModalProps & StoreProps & Actions & WithStyles;

const mapStateToProps = ({
  selection: { paxAmount, travelClass },
  ux: { travelClasses },
  enableCompactWidget,
}): StoreProps => ({
  paxAmount,
  travelClass,
  travelClasses,
  enableCompactWidget,
});

@withStyles()
@connectStore({ mapStateToProps, actions })
export default class PaxAmountModal extends Component<PaxAmountModalProps> {
  setPaxAmount = (paxAmount: PaxAmount): void => {
    const { setPaxAmount } = this.props as EffectiveProps;
    const { adults, infants } = paxAmount;
    setPaxAmount({ ...paxAmount, infants: Math.min(adults, infants) });
  };

  setPassenger = (type: PaxAmountKey, newAmount: number): void => {
    const { paxAmount } = this.props as EffectiveProps;
    this.setPaxAmount({ ...paxAmount, [type]: newAmount });
  };

  setTravelClass = (travelClass: TravelClass): void => {
    const { setTravelClass } = this.props as EffectiveProps;
    setTravelClass(travelClass);
  };

  get availableTravelClasses(): TravelClass[] {
    const { travelClasses } = this.props as EffectiveProps;
    return travelClasses;
  }

  render({ tx, paxAmount, travelClass, enableCompactWidget }: EffectiveProps): h.JSX.Element {
    const options: PaxSelectionOption[] = getPaxSelectionOptions(paxAmount);

    return (
      <PaxAmountModalBase enableCompactWidget={enableCompactWidget}>
        <Column grow={false} class={tx('ps-large-x')}>
          {options.map(
            (option: PaxSelectionOption, i: number): h.JSX.Element => (
              <PaxSelection
                key={option.type}
                class={tx({ 'border-bottom': !enableCompactWidget && i < options.length - 1 })}
                option={option}
                onPassengerChange={this.setPassenger}
                autofocus={i === 0} // Focus first
              />
            )
          )}
        </Column>
        {enableCompactWidget && (
          <Column grow={false}>
            {this.availableTravelClasses.map((t: TravelClass) => (
              <TravelClassRadio
                class={tx('border-top ps-large-x')}
                key={t}
                value={t}
                checked={t === travelClass}
                onSelection={this.setTravelClass}
                enableCompactWidget
              />
            ))}
          </Column>
        )}
      </PaxAmountModalBase>
    );
  }
}
